export default "__VITE_ASSET__BYBCRr5U__"